import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useCompanyId } from 'src/core/modules/app/hooks/useCompanyId';
import { getIsRequestCardLimitsIncreaseEnabled } from 'src/core/selectors/globalSelectors';

import { useGetCardLimitsIncreaseStatus } from './useGetCardLimitsIncreaseStatus';

export const useCardLimitsIncreaseStatus = () => {
  const companyId = useCompanyId();
  const isRequestCardLimitsIncreaseEnabled = useSelector(
    getIsRequestCardLimitsIncreaseEnabled,
  );
  const query = useGetCardLimitsIncreaseStatus({
    companyId,
    enabled: isRequestCardLimitsIncreaseEnabled,
  });

  const { isLimitsApproved, canRequestIncrease } = useMemo(
    () => ({
      isLimitsApproved: query.data?.status === 'approved',
      canRequestIncrease: query.data?.status !== 'approved',
    }),
    [query.data?.status],
  );

  return {
    ...query,
    isLimitsApproved,
    canRequestIncrease,
    isRequestCardLimitsIncreaseEnabled,
  };
};
